export default __webpack_public_path__ + "static/27-cyber-eye-33ffb3c8059a2ff25a3e01c4a3ec7ccc.png";